export const resetMedia = (eventId: string) => {
  const media = document
    .getElementsByClassName(`image-gallery-${eventId}`)[0]
    .querySelectorAll('video');

  media.forEach((mediaItem) => {
    mediaItem.pause();
  });
};
